export enum HeaderLayoutElementsEnum {
	HELP = 'HELP',
	NAME = 'NAME',
	NAV = 'NAV',
	NOTIFICATION = 'NOTIFICATION',
	PROFILE = 'PROFILE',
	UNIT = 'UNIT',
	BUILDINFO = 'BUILDINFO',
	SETTINGS = 'SETTINGS',
	FEE_MANAGEMENT = 'FEE_MANAGEMENT',
}

export enum UrlParamsEnum {
	DOC_MANAGEMENT = 'doc-management',
}

export enum UrlParamStateEnum {
	OPEN = 'open',
}
